<style lang="less">
.charge{
	.toidentity{
		color: #032;
	}
}
</style>

<template>
	<!-- Main charge 余额转入 -->
	<section class="charge">
		<!-- <toptips tips="身份证照未通过验证，将影响下一笔收益">
			<slot>
				<span class="toidentity">立即验证</span>
			</slot>
		</toptips> -->
		<toptips tips="因未满 18 岁无法注册基金账户，本次转入不产生收益"  v-if="identity_detail.age < 18"></toptips>

		<div class="form">
			<money
				title="转入金额"
				:price="order.amt"
				placeholder="建议转入 100 元以上的金额"
				v-on:price="setPrice">
			</money>
		</div>

		<div class="form_space"></div>

		<div class="form">
			<itembank v-on:bankSelect="bankSelect"></itembank>
		</div>

		<div class="form_space"></div>

		<div class="form">
			<div class="tips">{{tips}}</div>
		</div>

		<!-- <agreement :agree="agree" v-on:toggleAgree="toggleAgree">
			<div slot="agree">
				<span>我已阅读并同意</span>
				<router-link to="/text">《用户服务协议》</router-link>
			</div>
		</agreement> -->

		<footbtn btn-txt="下一步" :is-on="isActive" @click.native="next"></footbtn>

	</section>
</template>

<script>
	/*
		global androidJs
		global Finish
		global track
	*/
	import android from '@flyme/jr/js/android.js';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import agreement from '@flyme/jr/flyme7/component/agreement/agreement.vue';

	import toptips from '../components/toptips.vue';
	// import agreement from '../components/agreement.vue';
	import itembank from '../components/itembank.vue';
	import money from '../components/inputmoney.vue';
	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				tips: '',
				agree: true,
				identity_detail: {
					age: 22
				},
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				order: {
					amt: '',
					order_type: 10,
					bacc_no_i: '',
					bacc_no_l4: '',
					sys_reserved_info: {},
					app_info: ''
				},
				billPayData: {}
			};
		},
		computed: {
			isActive: function() {
				if (this.agree && this.order.amt > 0) {
					return true;
				}else{
					return false;
				}

			}
		},
		components: {
			itembank,
			poplist,
			toptips,
			footbtn,
			agreement,
			money
		},
		created: function () {
			this.getAge();
		},
		mounted: function () {
			this.getUserInfo();
			android('hideLoadingDialog');
		},
		methods: {
			getAge: function () {
				let _this = this;
				axios.post(apis.identity_query_detail, {
					show_type: 0
				}).then(function(d) {
					console.log('identity_query_detail', d);
					console.log('1111111111111111111111', d.value.age);
					_this.identity_detail.age = d.value.age;
				});
			},
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, function (d) {
					_this.order.sys_reserved_info = JSON.stringify({uid: d.userId});
					_this.getPhonInfo();
				});
			},
			getPhonInfo: function () {
				let app_info = {
					sn: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'sn'})),
					imei: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'imei'})),
					mac: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'})),
					flyme_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'flymeVersion'})),
					app_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'app_v'})),
					device_model: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'}))
				};
				this.order.app_info = JSON.stringify(app_info);
			},
			bankSelect: function (d) {
				this.order.bacc_no_i = d.bank_acc_no_index;
				this.order.bacc_no_l4 = d.bank_no_last4;
				this.order.acc_type = d.bank_acc_type;
				this.order.bank_name = d.bank_name;
				this.order.phone = d.phone;
			},
			toggleAgree: function () {
				this.agree = !this.agree;
			},
			setPrice: function (d) {
				this.order.amt = d;
			},
			next: function () {
				let _this = this;
				if (!this.isActive) {
					return;
				}
				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.acct_order_create, this.order).then(function(d) {
					console.log('acct_order_create', d);
					if (d.code != 200) {
						_this.tips = d.message;
						android('hideLoadingDialog');
					}else{
						if (d.value.server_vld_types.indexOf('2') > -1) {
							// 使用支付密码
							_this.prepay(d.value);
						}else {
							android('hideLoadingDialog');
							// _this.$router.replace({path: '/account/codepay', query: {data: JSON.stringify(d.value), app_info: _this.order.app_info, sys_reserved_info: _this.order.sys_reserved_info} });
							// return;
							android('startPageWithCallback', {
								url: config.staticURL + '/#/account/codepay?data='+ JSON.stringify(d.value) + '&app_info=' + _this.order.app_info + '&sys_reserved_info=' + _this.order.sys_reserved_info,
								start_type:1,
								data:'',
								display:{
									title:'验证手机号'
								}
							}, function (d) {
								if (d.pages == 'Account_result') {
									Finish('Account_charge');
								}
							});
						}
					}
				});
			},
			prepay: function (d) {
				let _this = this;
				axios.post(apis.acct_order_prepay, {
					order_id: d.order_id,
					vld_type: 2,
					app_info: this.order.app_info
				}).then(function(data) {
					console.log('acct_order_prepay', data);
					if (data.code != 200) {
						_this.tips = data.message;
						android('hideLoadingDialog');
					}else{
						let payData = {
							order_id: d.order_id,
							vld_type: 2,
							vld_token: data.value.token,
							vld_req: data.value.vld_req,
							sys_reserved_info: _this.order.sys_reserved_info,
							app_info: _this.order.app_info
						};
						_this.billPayData = payData;
						_this.pwdPay(payData);
					}
				});
			},
			pwdPay: function (prepay) {
				//指纹支付
                let _this = this;

                window.G_chagre_PayPwd_check = _this.paypwd_checked;
                // window.C = _this.changeBanchCard;

				let req_data = {
					req_data_content: prepay.vld_req.pay_pwd_req,
					sign: prepay.vld_req.sign
				};

                var d ={
                    validate_scene: "ecash_charge_pwd",
                    json_param: {
                        title: '使用' + _this.order.bank_name + ' 支付 ' + _this.order.amt + ' 元',
                        trade_id: JSON.stringify(req_data),
                        title_mark_text: _this.order.bank_name,
                        // title_mark_color: ""
                        title_click_callback: 'C'
                    }
                };

                // androidJs.doAndroidAction("requestPwdConfirm", JSON.stringify(d), "G");
                androidJs.doAndroidAction("requestPwdConfirm", JSON.stringify(d), "G_chagre_PayPwd_check");

			},
			paypwd_checked: function (code, msg, value) {
				let _this = this;
				if (code === 0) {
				//验证成功
					this.orderpay(value);
				}else if(code === -1){
					android('hideLoadingDialog');
					console.log('cancle 动作，不做处理');
				}else{
					android('hideLoadingDialog');
					window.G_dialogOk = _this.dialogOk;
					android('showDialog', {
						title: '',
						message: msg,
						okCallBack: 'G_dialogOk'
					});
				}
			},
			dialogOk: function () {
			},
			orderpay: function (data) {
				let _this = this;
				this.billPayData.vld_data = data;
				axios.post(apis.acct_order_pay, this.billPayData).then(function(d) {
					android('hideLoadingDialog');
					if (d.code != 200) {
						_this.tips = d.message;
						track('event_acct_order_pay', {
							way: 'paypwd',
							result: 'faild'
						});
					}else{
						if (d.value.resp_code == 23005) {
							track('event_acct_order_pay', {
								way: 'paypwd',
								result: 'faild'
							});
							window.G_charge_desc = _this.charge_desc;
							android('showDialog', {
								title: '',
								message: d.value.pay_status_remark,
								okText: '升级',
								cancelText: '暂不',
								okCallBack: 'G_charge_desc',
								cancelCallback: '',
								dismissCallback: ''
							});
						} else {
							track('event_acct_order_pay', {
								way: 'paypwd',
								result: 'success'
							});
							_this.$router.replace({path: '/account/result', query: {pay_order_id: d.value.pay_order_id, isAccount: true} });
						}
					}
				});
			},
			charge_desc: function () {
				this.$router.replace({ path: '/verify' });
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Account_charge.vue